import ga4Api from '@/packages/jsapi/logger/ga4';
import { jumpToUrl } from '@/services/url';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import { useEffect, useState } from 'react';
import './options.scss';
// tslint:disable-next-line: no-import-side-effect
// import './translationKeys_options';

const isSelect = (skuOption: Array<any>, option: string, optionName: string) => {
  for (let item of skuOption) {
    if (item?.type === option && item?.value === optionName) {
      return true;
    }
  }
  return false;
};

export const ProductOptions = (props: any) => {
  const { onClick, productOptions, skuList, selectedVariant, type } = props;
  const selectedTags: string[] = selectedVariant?.skuOption.map((item: any) => item.value) || [];
  const optionDict = selectedVariant.skuOption.reduce((prev: any, curr: any) => {
    prev[curr.type] = curr.value;
    return prev;
  }, {});

  const isSelectSku = (skuOption: Array<any>, length = 1, start = 0) => {
    let optionList: Array<any> = [];
    let selectedOptionList: Array<any> = [];
    productOptions.forEach((item: any, inx: number) => {
      let obj = selectedVariant.skuOption.find((child: any) => child.type === item.type);
      let obj1 = skuOption.find((child: any) => child.type === item.type);
      selectedOptionList.push(obj);
      optionList.push(obj1);
    });
    for (let i = 0; i < length; i++) {
      if (optionList[i].value !== selectedOptionList[i].value) {
        return false;
      }
    }
    return true;
  };

  const productStock = (index: number, option: any, optionName: any) => {
    let count = 0;
    if (index === 0) {
      for (let item of skuList) {
        const isSku = isSelect(item.skuOption, option, optionName);
        if (isSku) {
          count += item.inventoryQuantity;
        }
      }
      return count;
    }
    if (index === selectedVariant.skuOption.length - 1) {
      for (let item of skuList) {
        const isSku = isSelect(item.skuOption, option, optionName);
        if (isSku && isSelectSku(item.skuOption, index, 0)) {
          return item.inventoryQuantity;
        }
      }
    }
    if (index > 0 && index < selectedVariant.skuOption.length - 1) {
      for (let item of skuList) {
        const isSku = isSelect(item.skuOption, option, optionName);
        if (isSku && isSelectSku(item.skuOption, index, 1)) {
          count += item.inventoryQuantity;
        }
      }
      return count;
    }
    return count;
  };
  return (
    <div className='hho-product-options-wrapper'>
      {productOptions.map((option: any, index: number) => {
        return (
          <section className={`hho-product-option-wrapper index-${index}`} key={option.name}>
            <div className='option-title'>{option.name}</div>
            <div className='option-selections' data-option={option.value}>
              {option.value.map((optionName: any, inx: number) => {
                const isOptionSelected: boolean = _includes(selectedTags, optionName);
                return (
                  <span key={inx}>
                    <span
                      key={inx}
                      className={`option-tag ${isOptionSelected ? 'selected' : ''}`}
                      onClick={() => {
                        optionDict[option.type] = optionName;
                        onClick(Object.values(optionDict));
                      }}
                    >
                      {optionName}
                    </span>
                  </span>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
};
